import { ApiContent, ApiContentItemAny } from "@/components/cms/items/schemas"
import { ApiMediasFile } from "@/services/medias/schemas"

export const extractFilesFromContentItem = (item: ApiContentItemAny): ApiMediasFile[] => item.files
export const extractFilesFromContent = (content: ApiContent): ApiMediasFile[] =>
  A.reduce(content.items, [] as ApiMediasFile[], (list, item) => [...list, ...extractFilesFromContentItem(item)])
